import React from 'react';
import PropTypes from 'prop-types';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import { copyAssessment } from 'legacy-src/queries';
import { client } from 'legacy-src/store';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const duplicate = async (assessmentId, masterSubjectId, router) => {
  const {
    data: {
      copyAssessment: { ok, newAssessment },
    },
  } = await client.mutate({
    mutation: copyAssessment,
    variables: {
      assessmentId,
      subjectId: masterSubjectId,
    },
  });

  if (ok) {
    const { itemId } = newAssessment;
    router.push(
      `/${masterSubjectId}/question_bank/create?editMode=true&quizId=${itemId}`,
    );
  }
};

const DuplicateQuizAction = (props) => {
  const { assessmentId, onClose, subjectData, router, label, role, disabled } =
    props;
  const { id: masterSubjectId } = subjectData;

  return (
    <AccessibilityWrapper>
      <SingleAction
        role={role}
        tabIndex={0}
        onClick={async () => {
          await duplicate(assessmentId, masterSubjectId, router);
          onClose();
        }}
        iconName="duplicate"
        disabled={disabled}
      >
        {label || <span className="item-text">Duplicate Quiz</span>}
      </SingleAction>
    </AccessibilityWrapper>
  );
};

DuplicateQuizAction.propTypes = {
  label: PropTypes.any,
  role: PropTypes.string,
};

DuplicateQuizAction.defaultProps = {
  label: '',
  role: 'button',
};

const mapStateToProps = (state) => {
  const { subject } = state;

  return {
    subjectData: subject.data,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps),
)(DuplicateQuizAction);

export { duplicate };
